import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import "./CareerMojo.css";

function CareerMojo() {
  return (
    <Container fluid className="careermojo-section">
      <Particle />
      <Container className="careermojo-shell">
        <section className="careermojo-hero">
          <p className="careermojo-eyebrow">Building CareerMojo</p>
          <h1>Credibility-first opportunity matchmaking for early-career talent.</h1>
          <p className="lede">
            CareerMojo is the platform I'm actively prototyping, to match right people with the right opportunities with credibility, transparency and tranferability.
          </p>
          <div className="hero-grid">
            <div className="hero-pill">Entrepreneurship as the new bridge to opportunity.</div>
            <div className="hero-pill">Onboarding the first 100 customers now.</div>
            <div className="hero-pill">Actively Seeking Cofounders. Open to Exploring new Ideas.</div>
          </div>
          <p className="careermojo-release">
            A big <strong>CareerMojo release</strong> drops soon — February 16th, 2026, Sign up at careermojo.tech for early access now. 🎄
          </p>
        </section>

        <section className="careermojo-live-preview">
          <div className="section-heading">
            {/* <h2>CareerMojo</h2> */}
          </div>
          <div className="preview-frame">
            <iframe
              src="https://careermojo.tech/"
              title="CareerMojo live site"
              loading="lazy"
              referrerPolicy="no-referrer"
            />
          </div>
          <div className="preview-actions">
            <a href="https://careermojo.tech/" target="_blank" rel="noreferrer" className="cta-btn primary">
              Open careermojo.tech
            </a>
            <a href="mailto:varshini.balaji@creativethee.com" className="cta-btn secondary">
              Say hello
            </a>
          </div>
        </section>
      </Container>
    </Container>
  );
}

export default CareerMojo;
